<template>
  <div>
    <el-divider>{{$t('私有属性')}}</el-divider>
    <el-form-item :label="$t('默认值')">
        <l-numInput v-model="data.default" v-bind="data" :unit.sync="data.unit"></l-numInput>
    </el-form-item>
    <el-form-item :label="$t('小数位')">
        <el-input  v-model="data.fix" type="number" :placeholder="$t('小数位限制，未设置时只能输入整数')"></el-input>
    </el-form-item>
    <!-- <el-form-item :label="$t('单位字段')" style="margin-bottom:8px;" >
        <l-select :options="getFields(data.table)" v-model="data.unitCode">
        </l-select>
    </el-form-item>
    <el-form-item :label="$t('默认单位')" v-if="data.units.length">
        <l-select :options="data.units" v-model="data.unit">
        </l-select>
    </el-form-item>
    <el-form-item :label="$t('单位')" v-else>
        <el-input  v-model="data.unit" :placeholder="$t('有单位时，显示在数字后面')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('单位显示在后面')">
        <el-switch v-model="data.appendUnit"></el-switch>
    </el-form-item> -->
    <el-form-item :label="$t('金额格式')">
        <el-switch v-model="data.money" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('金额大写')">
        <el-switch v-model="data.upperCase" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否必填')">
        <el-switch v-model="data.required" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否只读')">
        <el-switch v-model="data.readonly" ></el-switch>
    </el-form-item>
    <!-- <el-divider>{{$t('可选单位')}}</el-divider>
    <div style="text-align: center;margin-bottom:16px;" >
        <el-radio-group v-model="data.dataType" size="mini" @change="handleDataTypeChange" >
            <el-radio-button label="1">{{$t('静态数据')}}</el-radio-button>
            <el-radio-button label="2">{{$t('数据字典')}}</el-radio-button>
            <el-radio-button label="3">{{$t('数据源')}}</el-radio-button>
        </el-radio-group>
    </div> -->
    <!--静态数据-->
    <!-- <div v-if="data.dataType == 1" >
        <draggable
            :list="data.units"
            :group="{ name: 'dic' }"
            ghost-class="set-item-ghost"
            handle=".drag-item">
            <div v-for="(item, index) in data.units"
                class="set-item"
                :key="index">
            <i class="drag-item el-icon-rank"></i>
            <el-input
                style="width:49%;margin-right:2%;"
                size="mini"
                v-model="item.label"
                :placeholder="$t('选项名')"></el-input>
            <el-input
                style="width:49%;"
                size="mini"
                v-model="item.value"
                :placeholder="$t('选项值')"></el-input>
            <el-button 
                @click="handleRemoveDatas(index)"
                circle
                plain
                type="danger"
                size="mini"
                icon="el-icon-minus"
                class="delete-item"
                style="padding: 4px;"></el-button>
            </div>
        </draggable>
        <div style="padding-left:22px;" >
            <el-button size="mini" type="text" icon="el-icon-circle-plus-outline" @click="handleAddDatas"  >{{$t('添加选项卡')}}</el-button>
        </div>
    </div> -->
    <!--数据字典-->
    <!-- <div v-else-if="data.dataType == 2" >
        <l-tree-select
            v-model="data.dataCode"
            :options="dataItemClassifysTree"
            :placeholder="$t('请选择')"
            size="mini"
            :parent="false"

            @change="handleDataItemChange"
        >
        </l-tree-select>
    </div> -->
    <!--远端数据-->
    <!-- <div v-else >
        <el-form-item :label="$t('数据源')">
            <l-select  
                    v-model="data.dataCode"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="dataSource" 
                    labelKey="f_Name" 
                    valueKey="f_Code"

                    @change="handleDataSourceChange"
                >
            </l-select>
        </el-form-item>
        <el-form-item label="值">
            <l-select  
                    v-model="data.dataValueKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myColNameList" 

                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>
        <el-form-item :label="$t('标签')">
            <l-select  
                    v-model="data.dataLabelKey"
                    :placeholder="$t('请选择')" 
                    size="mini" 
                    :options="myColNameList" 

                    @change="handleDataSourceKeyLabelChange"
                >
            </l-select>
        </el-form-item>

        <el-form-item :label="$t('上一级')">
            <l-select
                v-model="data.upCtrl"
                :placeholder="$t('请选择')"
                size="mini"
                :options="componentOptions"
            >
            </l-select>
        </el-form-item>
    </div> -->
  </div>
</template>

<script>
export default {
    name: "config-num",
    props: ['data'],
    inject: ["formDesign"],
    data () {
        return{}
    },
    computed:{
        dataItemClassifysTree(){
            if(this.lr_dataItemClassifysTree){
                return this.lr_dataItemClassifysTree
            }
            else{
                return []
            }
        },
        dataSource(){
            if(this.lr_dataSource){
                return this.lr_dataSource
            }
            else{
                return []
            }
        }
    },
    watch: {
        "data.units" () {
            console.log('data.units---change')
            if (!this.data.unit) return this.data.unit = this.data.units[0].value
            if (!this.data.units.find(e => e.value == this.data.unit)) return this.data.unit = this.data.units[0].value
        }
    },
    methods: {
        getFields(tableName){
            let table = this.formDesign.dbTables.find(t=>t.name == tableName) || {}
            const columns = table.columns || []
            return columns.map(t=>({...t,value:t.name,label:t.coment? `${t.name}(${t.coment})` : t.name}))
        },
        handleDataTypeChange(){
            this.data.dataCode = '';
            this.data.dataValueKey = '';
            this.data.dataLabelKey = '';

            this.data.unit = '';
        },
        handleRemoveDatas(index){
            if(this.data.unit == this.data.units[index].value){
                this.data.unit = '';
            }
            this.data.units.splice(index,1);
        },
        handleDataItemChange(){
            this.data.unit = ''
            if(!this.$validatenull(this.data.dataCode) && this.lr_loadDataItem){
                this.lr_loadDataItem(this.data.dataCode)
            }
        },
        handleDataSourceChange(){
            this.data.unit = ''
            this.data.dataValueKey = ''
            this.data.dataLabelKey = ''
            if(!this.$validatenull(this.data.dataCode) && this.lr_loadDataSourceColNames){
                this.lr_loadDataSourceData(this.data.dataCode)
                this.lr_loadDataSourceColNames(this.data.dataCode)
            }
        },
        handleAddDatas(){
            this.data.units.push({label:'选项' + (this.data.units.length + 1) ,value:this.data.units.length + 1});
        },
        handleDataSourceKeyLabelChange(){
            this.data.default = ''
        }
    }
}
</script>

